const isIframe = () => window.location !== window.parent.location;

export default isIframe;
